module.exports = __webpack_public_path__ + "static/media/moemoe_tips56.203ca090.jpg";